import { Stack } from "@mui/material";

import DemoToggle from "./components/DemoToggle/DemoToggle";
import Context from "./context";
import JsonResult from "./JsonResult";
import PositionsTableCard from "./PositionsTableCard";
import useResultsActionsStore from "./store";

// ----------------------------------------------------------------------

export const PositionsResult = () => {
	const [state, actions] = useResultsActionsStore();
	return (
		<Context.Provider value={{ state, actions }}>
			<Stack sx={{ mt: { xs: 5, sm: 5 }, alignItems: "center" }}>
				<DemoToggle />
				{!state.showTable ? <JsonResult /> : <PositionsTableCard />}
			</Stack>
		</Context.Provider>
	);
};

export default PositionsResult;
